import { NgModule } from '@angular/core';
import { SafehtmlPipe } from './safehtml/safehtml.pipe';
import { TranslateLabelPipe } from './translate-label/translate-label.pipe';

@NgModule({
  declarations: [
    TranslateLabelPipe,
    SafehtmlPipe
  ],
  exports: [
    TranslateLabelPipe,
    SafehtmlPipe
  ]
})
export class PipesModule {}
